module.exports = __webpack_public_path__ + "img/view_recent_search_icon.71c1e674.png";